export const AccountAndPassword = 'AccountAndPassword';
export const TOKEN_KEY = 'Admin-Token';

interface IThirdUrl {
  GOOGLE?: string;
  FACEBOOK?: string;
  APPLE?: string;
  MICROSOFT?: string;
}
const THIRD_URL: IThirdUrl = {};

interface IPOLICY {
  PRIVACY: string;
  TERMS: string;
  CANCELLATION: string;
}
const POLICY: IPOLICY = {} as IPOLICY;

if (process.env.REACT_APP_RUN_TYPE === 'prod') {
  THIRD_URL.GOOGLE =
    'https://accounts.google.com/o/oauth2/v2/auth?client_id=450337642319-n3ekhhddgudruevlcpotrnih9uiu1k3n.apps.googleusercontent.com&scope=https://www.googleapis.com/auth/userinfo.email&redirect_uri=https://auth.gvpn.io/oauth/callback/google&response_mode=form_post&response_type=code&prompt=select_account&service=lso&o2v=2&flowName=GeneralOAuthFlow';
  THIRD_URL.APPLE =
    'https://appleid.apple.com/auth/authorize?client_id=com.gvpn.gvpn-signinwithapple&redirect_uri=https://auth.gvpn.io/oauth/callback/apple&response_mode=form_post&response_type=code&scope=email%20name';

  POLICY.PRIVACY = 'https://www.gvpn.io/privacy-policy';
  POLICY.TERMS = 'https://www.gvpn.io/terms-of-use';
  POLICY.CANCELLATION = 'https://www.gvpn.io/account-cancellation-policy';
} else {
  THIRD_URL.GOOGLE =
    'https://accounts.google.com/o/oauth2/v2/auth?client_id=518973584058-dl8ekb9g0kqnake5dv9bret5frnpvn5g.apps.googleusercontent.com&scope=https://www.googleapis.com/auth/userinfo.email&redirect_uri=https://auth-test.gvpn.io/oauth/callback/google&response_mode=form_post&response_type=code&prompt=select_account&service=lso&o2v=2&flowName=GeneralOAuthFlow';
  THIRD_URL.APPLE =
    'https://appleid.apple.com/auth/authorize?client_id=com.gvpn.gvpn-dev-signinwithapple&redirect_uri=https://auth-test.gvpn.io/oauth/callback/apple&response_mode=form_post&response_type=code&scope=email%20name';

  POLICY.PRIVACY = 'https://testpay.gvpn.io:7000/privacy-policy';
  POLICY.TERMS = 'https://testpay.gvpn.io:7000/terms-of-use';
  POLICY.CANCELLATION =
    'https://testpay.gvpn.io:7000/account-cancellation-policy';
}
export { THIRD_URL, POLICY };
